import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { suggestedUsersReducer } from './suggested-user.reducer';
import { EffectsModule } from '@ngrx/effects';
import { SuggestedUserEffects } from './suggested-user.effects';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature('suggested-users', suggestedUsersReducer),
    EffectsModule.forFeature([SuggestedUserEffects]),
  ],
  providers: [],
})
export class SuggestedUserStoreModule {}
